import { defineModule } from "direct-vuex";
import { moduleActionContext } from "@/store";
import {
  addKsefCert,
  checkKsefCertificateExists,
  getOfficeConfiguration,
  removeKsefCert,
  saveOfficeConfiguration,
  testKsefLogin,
} from "@/requests/ksefCert";

export interface AdministrationKSEFInterface {
  isAuthorizationCertExist: boolean;
  isOfflineCertExist: boolean;
  ksefConfigurationSystem: "optima" | "symfonia";
}

export const AdministrationKSEFState: AdministrationKSEFInterface = {
  isAuthorizationCertExist: false,
  isOfflineCertExist: false,
  ksefConfigurationSystem: "optima",
};

const AdministrationKsefCertModule = defineModule({
  state: AdministrationKSEFState as AdministrationKSEFInterface,
  namespaced: true as const,
  getters: {},
  mutations: {
    saveIsAuthorizationCertExist(state, param: boolean) {
      state.isAuthorizationCertExist = param;
    },
    saveIsOfflineCertExist(state, param: boolean) {
      state.isOfflineCertExist = param;
    },
    saveKsefConfigurationSystem(state, param: "optima" | "symfonia") {
      state.ksefConfigurationSystem = param;
    },
  },
  actions: {
    async checkKsefAuthorizationCertificateExists(context) {
      const { commit } = _moduleActionContext(context);
      const result = await checkKsefCertificateExists("authorize");
      commit.saveIsAuthorizationCertExist(result);
    },
    async checkKsefOfflineCertificateExists(context) {
      const { commit } = _moduleActionContext(context);
      const result = await checkKsefCertificateExists("offline");
      commit.saveIsOfflineCertExist(result);
    },
    async saveOfficeConfiguration(context, param: "optima" | "symfonia") {
      const { rootDispatch, dispatch } = _moduleActionContext(context);
      await saveOfficeConfiguration(param);
      rootDispatch.popup.addOperationSuccessfulSnackbar();
      dispatch.getOfficeConfiguration();
    },
    async saveKsefCertificate(
      context,
      payload: { certificateContent: string; keyContent: string; certificatePassword: string; type: string }
    ) {
      const { rootDispatch } = _moduleActionContext(context);

      await addKsefCert({
        certString: payload.certificateContent,
        encryptedPrivateKey: payload.keyContent,
        password: payload.certificatePassword,
        type: payload.type,
      });

      rootDispatch.popup.addSavedOkSnackbar();
    },
    async getOfficeConfiguration(context) {
      const { commit } = _moduleActionContext(context);
      const result = await getOfficeConfiguration();
      commit.saveKsefConfigurationSystem(result);
    },
    async removeKsefCertificate(context, type: string) {
      const { rootDispatch } = _moduleActionContext(context);
      await removeKsefCert(type);
      rootDispatch.popup.addOperationSuccessfulSnackbar();
    },
    async testKsefLogin(context) {
      const { rootDispatch } = _moduleActionContext(context);
      await testKsefLogin();
      rootDispatch.popup.addOperationSuccessfulSnackbar();
    },
  },
});
export default AdministrationKsefCertModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, AdministrationKsefCertModule);
